<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/Permissions/Permissions/table-headers'

import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTablePermissions',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
